<template>
  <div class="root">
    <select
      v-model="selected"
      class="select-box"
      @change="onChanged"
      :class="{ noSelect: selected === '' }"
    >
      <option value="" style="display: none">選択してください</option>
      <option v-for="(item, index) in itemList" :key="index">
        {{ item }}
      </option>
    </select>
    <img class="triangle" src="@/assets/chevron.svg" />
  </div>
</template>

<script>
export default {
  name: "select-box",
  props: {
    itemList: { type: Array, required: true },
    initialValue: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      selected: this.initialValue,
    };
  },
  methods: {
    onChanged() {
      this.$emit("change-value", {
        text: this.text,
        ans: this.selected,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.select-box {
  width: 100%;
  padding: $very-little-margin;
  border: none;
  border-bottom: 1px solid #373737;
  option {
    color: black;
  }
  &.noSelect {
    color: #d8d8d8;
  }
}
.root {
  position: relative;
  .triangle {
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Atoms/SelectBox.vue